import { useTranslation } from 'react-i18next';
import { useModuleStrings } from '@platform/modularity/useModuleStrings';
import { statusColor } from '@platform/core/lib/statusColors';
import type { IOverviewStagesProps } from './IOverviewStagesProps';

/**
 * «Етапи» на огляді (прототип v4): смуга 12px із сегментом на кожен статус визначення (частка від усіх записів) і легенда — крапка 8px,
 * підпис статусу, лічильник моноширинним; кольори — як крапки статусів у списках. Без статусів не рендериться.
 */
export function OverviewStages({ rt, buckets, total }: IOverviewStagesProps) {
  const { t } = useTranslation();
  const strings = useModuleStrings();
  const counts = new Map(buckets.map((b) => [b.value, b.count]));
  const stages = rt.statuses.list.map((s) => ({
    value: s.value, label: strings.status(rt.key, s.value, s.label), count: counts.get(s.value) ?? 0, color: statusColor(rt.statuses, s.value, rt.key),
  }));
  if (!stages.length) return null;
  const share = (n: number) => `${((n * 100) / Math.max(1, total)).toFixed(1)}%`;
  return (
    <section className="mp-panel">
      <strong className="mp-panel__title">{t('overview.stages')}</strong>
      <div className="mp-stagebar" role="img" aria-label={stages.map((s) => `${s.label}: ${s.count}`).join(', ')}>
        {stages.map((s) => <div key={s.value} title={`${s.label} · ${s.count}`} style={{ width: share(s.count), background: s.color }} />)}
      </div>
      <div className="mp-legend">
        {stages.map((s) => (
          <span key={s.value} className="mp-legend__item">
            <span className="mp-dot" style={{ background: s.color }} />{s.label}<span className="mp-num">{s.count}</span>
          </span>
        ))}
      </div>
    </section>
  );
}
